import { createStackNavigator } from '@react-navigation/stack'

import { useTranslation } from '~hooks'
import { OffersListScreen } from '~screens'
import { Routes } from '~types/routesNames'

const { Navigator, Screen } = createStackNavigator<OffersStackParamList>()

export const OffersStack = (): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Navigator>
      <Screen
        component={OffersListScreen}
        name={Routes.OffersList}
        options={{ title: t('navigation.screen_titles.offers_list'), headerShown: false }}
      />
    </Navigator>
  )
}
